import styled from 'styled-components';

export const BrandAwarenessUsageOurMethodStyles = styled.div`
  .container {
    margin-top: 100px !important;

    @media (max-width: 991px) {
      margin-top: 50px !important;
    }
  }

  .our-methodology {
    width: 100%;
  }
`;
